import React from 'react';
import { StyleSheet } from 'react-native';
import Button from 'design-system/Button';
import { CardView, rem } from 'design-system';
import ListEmptyView from 'design-system/ListEmptyView';
const strings = {
    title: 'No breaches',
    subTitle: 'Connect your phone numbers and emails to start tracking',
    button: 'Add details',
};
const NoBreaches = ({ onAddDetails }) => (<CardView style={styles.container} noMarginTop>
    <ListEmptyView compact title={strings.title} subTitle={strings.subTitle} happy>
      <Button brandReversed small hug title={strings.button} onPress={onAddDetails}/>
    </ListEmptyView>
  </CardView>);
const styles = StyleSheet.create({
    container: {
        padding: rem(24),
    },
});
export default NoBreaches;
